import type {
  PortfolioFilteredStatisticsResource,
  PortfolioProgressGroupResource,
  PortfolioStudentProgressGroupedResource,
  PortfolioStudentProgressResource,
} from "api/generated";
import type {
  MentorStudentPortfolio,
  MyStudentsProgress,
  MyStudentsProgressGroup,
  PortfolioStatistics,
} from "portfolio/types";
import { portfolioShallowStudentFromDto } from "./portfolioShallowStudent.mapper";

const portfolioStatisticsFromDto = (
  dto: PortfolioFilteredStatisticsResource,
): PortfolioStatistics => ({
  totalActivities: dto.total_activities,
  totalSkills: dto.total_skills,
  totalAttachments: dto.total_attachments,
  totalReferences: dto.total_references,
});

const progressGroupFromDto = (
  dto: PortfolioProgressGroupResource,
): MyStudentsProgressGroup => ({
  name: dto.name,
  studentAmount: dto.student_amount,
});

export const studentProgressFromDto = (
  dto: PortfolioStudentProgressResource,
): MentorStudentPortfolio => ({
  id: dto.id,
  student: portfolioShallowStudentFromDto(dto.student),
  statistics: portfolioStatisticsFromDto(dto.statistics),
  openTasksAmount: dto.open_tasks_amount,
  expiredTasksAmount: dto.expired_tasks_amount,
  closedTasksAmount: dto.closed_tasks_amount,
  lastActivityAt: dto.last_activity_at ? new Date(dto.last_activity_at) : null,
});

export const studentProgressGroupedFromDto = (
  dto: PortfolioStudentProgressGroupedResource,
): MyStudentsProgress => ({
  groups: dto.groups.map(progressGroupFromDto),
  data: dto.data.map(studentProgressFromDto),
  activeGroup: dto.activeGroup ?? null,
  meta: {
    hasMore: dto.meta.has_more,
    offset: dto.meta.offset,
    take: dto.meta.take,
    total: dto.meta.total,
  },
});
